<script>
    import { run } from 'svelte/legacy';
    import { onMount } from 'svelte';
    import { fetchData } from '../base';
    import Seo from '../component/element/Seo.svelte';
    import ManagerSection from '../component/homePage/ManagerSection.svelte';
    import { languageArrayStore } from '../store/languageArrayStore';
    import urlStore from '../store/urlStore';
    import FullLoading from '../component/Layout/FullLoading.svelte';
    import { pageStore } from '../store/pageDataStore';
    import AdminSortableBlocks from '../component/element/AdminSortableBlocks.svelte';
    import AnimatedText from '$lib/component/element/AnimatedText.svelte';
    import AdminEditButton from '$lib/component/element/AdminEditButton.svelte';
    import { getProcessedMultilineTranslatedText } from '$lib/base.js';
    import { enabledAdminView } from '$lib/store/adminStore.js';
    import { textStore } from '$lib/store/textStore';
    import { languageTagStore } from '../store/languageTagStore';

    // -- VARIABLES

    let isLoading = $state(true);
    let memberArray = $state([]);
    let blockArray = $state($pageStore.block[ 'ambassadors' ]);
    let internalTeamArray = $state([]);
    let ambassadorTeamArray = $state([]);
    let expertTeamArray = $state([]);
    let foundingTeamArray = $state([]);

    // -- FUNCTIONS

    async function loadData(
        )
    {
        try
        {
            isLoading = true

            let pageData =
                await fetchData(
                    '/api/get-team',
                    {
                        method: 'POST',
                        body: JSON.stringify(
                            {
                            },
                        ),
                        headers: { 'Content-Type': 'application/json' }
                    }
                    );


            memberArray = [ pageData.memberArray ]

            $pageStore.block[ 'ambassadors' ] = pageData.blockArray;

            blockArray = pageData.blockArray;

            
            internalTeamArray = pageData.memberArray.filter( ( member ) => member.type === 'internal' );
            ambassadorTeamArray = pageData.memberArray.filter( ( member ) => member.type === 'ambassador' );
            expertTeamArray = pageData.memberArray.filter( ( member ) => member.type === 'expert' );
            foundingTeamArray = pageData.memberArray.filter( ( member ) => member.type === 'founding' );
        }
        catch ( error )
        {
            console.error( 'Error:', error )
        }
        finally
        {
            isLoading = false;
        }
    }

    // function sortElementGroupArray(
    //     event
    //     )
    // {
    //     let sortedElementArray = event.detail.blockGroupArray;

    //     let isFounderArray = sortedElementArray.some(
    //         ( element ) => $founderArrayStore.find( ( founder ) => founder.id === element.id )
    //         );

    //     if ( isFounderArray )
    //     {
    //         founderArray = sortedElementArray;
    //     }
    //     else
    //     {
    //         managerArray = sortedElementArray;
    //     }
    // }

    // -- STATEMENTS

    onMount(
        async () =>
        {
            await loadData();

            // document.addEventListener( 'on-sort-element-group', sortElementGroupArray );
            
            // window.removeEventListener( 'on-sort-element-group', sortElementGroupArray );
        }
        );

    // ~~

    run(
        () =>
        {
            if ( $urlStore.pathname.includes( 'team' ) )
            {
                document.title = 'Team';
            }
        }
        );
</script>

<style lang="stylus">
    // -- IMPORTS

    @import '../../constant.styl';
    @import '../../mixin.styl';

    // -- CLASSES

    .divider
    {
        width: 80%;
        height: 1px;

        background-color: pureBlackColor;
    } 
</style>

<Seo
    metaTitle={ "Bamhub - Team" }
    metaDescription={ "Get to know a little more about our team and our ambassadors" }
    url={ 'https://bamhub.com' }
    languageData={ $languageArrayStore }
    path="team"
/>

{#if isLoading}
    <FullLoading />
{:else}
    <!-- <span class="heading-title color-light-gold" class:is-admin-enabled={ $enabledAdminView }>
        <AnimatedText text={ getProcessedMultilineTranslatedText( $textStore[ 'our-team-label' ], $languageTagStore ) } />
        <AdminEditButton
            type="text"
            slug="our-team-label"
            inset="-2.5rem -1rem auto auto"
            textToEdit={ $textStore[ 'our-team-label' ] }
            title={ "our-team-label" }
        />
    </span> -->

    <ManagerSection
        { internalTeamArray }
        { ambassadorTeamArray }
        { expertTeamArray }
        { foundingTeamArray }
    />

    <AdminSortableBlocks
        bind:blockArray={ memberArray }
        pageWithBlocks={ false }
        isManager={ true }
    />
{/if}
